require('../../modules/es7.array.flatten');
module.exports = require('../../modules/_core').Array.flatten;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/flatten.js
// module id = 1059
// module chunks = 0